var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-form-success d-flex align-items-center bg-light p-5"},[_c('div',{staticClass:"text-center"},[_vm._t("icon"),_c('p',{staticClass:"fs-2 fw-bold mb-5"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"fs-4 mb-3",domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._t("extra")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }